/**
 * Responsive bildevarianter. Filene genereres av `frontend/scripts/build-images.py` fra masterbildene i
 * `/app/.assets/masters` og ligger under `public/img/<mappe>/<navn>-<bredde>.<avif|webp>`.
 *
 * Hvert motiv beskrives én gang her (base-sti, tilgjengelige bredder og pikselmål for den største varianten),
 * slik at `<Picture>` kan sette srcset/sizes og width/height uten gjetting – og uten layout-hopp.
 */

const v = (base, widths, width, height) => ({ base, widths, width, height });

export const IMAGES = {
  /** Hero på forsiden: hjullaster til høyre i bruddet, åpen plass til overskriften (16:9) + stående beskjæring til mobil. */
  hero: v('/img/site/hero-hjullaster', [768, 1200, 1600, 2000], 2000, 1129),
  heroPortrait: v('/img/site/hero-hjullaster-portrait', [480, 640, 753], 753, 1129),
  /** Bildebånd: knuseverket ved fjorden. */
  knuseverk: v('/img/site/knuseverk-fjord', [768, 1200, 1600, 2000], 2000, 758),
  /** Prosjektpris-bakgrunn: fjorden. Bred beskjæring til desktop, kvadrat til mobil. */
  fjordWide: v('/img/site/fjord-wide', [1200, 1600, 2000], 2000, 1000),
  fjordSquare: v('/img/site/fjord-square', [640, 960], 960, 960),
  /** Levering: arbeidsskip ved kai. */
  arbeidsskip: v('/img/site/arbeidsskip', [640, 960, 1448], 1448, 1086),
  /** Om oss. */
  gravemaskiner: v('/img/site/gravemaskiner', [480, 768], 768, 960),
  gravemaskinerWide: v('/img/site/gravemaskiner-wide', [960, 1448], 1448, 1086),
  bigbags: v('/img/site/bigbags', [480, 768, 1254], 1254, 1254),
  /** Innlogging. */
  login: v('/img/brand/login-hjullaster', [640, 960, 1250], 1250, 844),
};

/** Produktbilder (900×900) ut fra katalogens `image`-felt, f.eks. `/img/produkter/big-bag-900.webp`. */
export function productImage(src) {
  const stem = String(src ?? '')
    .replace(/^.*\//, '')
    .replace(/\.[a-z0-9]+$/i, '')
    .replace(/-\d+$/, '');
  return v(`/img/produkter/${stem}`, [320, 640, 900], 900, 900);
}

export function srcSet(variant, ext) {
  return variant.widths.map((w) => `${variant.base}-${w}.${ext} ${w}w`).join(', ');
}

/** Reservebilde for nettlesere uten srcset-støtte: største WebP. */
export function fallbackSrc(variant) {
  return `${variant.base}-${variant.widths[variant.widths.length - 1]}.webp`;
}

/** Lenke som kan forhåndslastes (brukes av index.html for hero på forsiden). */
export function largest(variant, ext = 'avif') {
  return `${variant.base}-${variant.widths[variant.widths.length - 1]}.${ext}`;
}
